{
  "activity": {
    "appTrackingEnabled": "Allow app and website tracking",
    "appTrackingHint": "Name of the active app or browser domain and window title.",
    "appsDisabled": "App tracking is not enabled in this workspace.",
    "appsDisabledAdmin": "App tracking is not enabled (Settings › Activity).",
    "autoDescription": "empty = apps/websites as description",
    "backgroundHint": "Note: browsers only record the location while the app is open. Continuous background tracking will require a native app later.",
    "blur": "Store screenshots blurred",
    "blurHint": "Content is not readable; only the window layout is visible.",
    "blurred": "blurred",
    "consentApps": "Allow app and website tracking",
    "consentOff": "No consent",
    "consentOn": "Consented",
    "consentScreenshots": "Allow screenshots",
    "consentScreenshotsBlurred": "Allow blurred screenshots",
    "consentSwitch": "I consent to location tracking (revoking deletes my locations)",
    "consentText": "If you consent, the app sends your location roughly every {{interval}} minutes while a timer is running. Admins and your team managers can see it; it is deleted after {{days}} days.",
    "consentTitle": "Location tracking",
    "convertHint": "Consecutive segments (gap up to 5 minutes) are combined into one entry.",
    "convertSubmit": "Create entries",
    "convertTitle": "Convert to time entries",
    "convert_one": "Convert {{count}} segment",
    "convert_other": "Convert {{count}} segments",
    "converted": "converted",
    "convertedCount_one": "{{count}} entry created",
    "convertedCount_other": "{{count}} entries created",
    "days": "days",
    "deleteScreenshot": "Delete screenshot?",
    "desktopConsentText": "The workspace has enabled recording by the desktop client. Recording only happens while a timer runs; data is deleted after {{days}} days, immediately on withdrawal.",
    "desktopConsentTitle": "Consent: desktop client",
    "desktopDisableWarning": "Switching off deletes all stored screenshots or app data of the workspace.",
    "desktopHint": "The desktop client only records while a timer is running and only for people who have consented. Involve the works council and data protection officer before enabling, if applicable.",
    "desktopRetention": "Retention",
    "desktopTitle": "Desktop client: screenshots and app tracking",
    "disableWarning": "All recorded locations will be deleted when you save.",
    "disabled": "Location tracking is turned off in this workspace.",
    "disabledAdmin": "Location tracking is turned off. You can enable it under Settings › Locations.",
    "empty": "No locations on this day.",
    "entriesCount_one": "for {{count}} entry",
    "entriesCount_other": "for {{count}} entries",
    "gpsEnabled": "Allow location tracking",
    "gpsEnabledHint": "Each person decides in their profile whether to consent.",
    "interval": "Interval",
    "noAccess": "No permission to view this person’s locations.",
    "noScreenshots": "No screenshots on this day.",
    "noUsage": "No app usage on this day.",
    "person": "Person",
    "points_one": "{{count}} location point",
    "points_other": "{{count}} location points",
    "privacyNote": "Locations are only recorded while a timer runs and with consent, and are deleted automatically after {{days}} days.",
    "retention": "Retention",
    "screenshotAt": "Screenshot at {{time}}",
    "screenshotPrivacy": "Screenshots are deleted automatically after {{days}} days.",
    "screenshotsDisabled": "Screenshots are not enabled in this workspace.",
    "screenshotsDisabledAdmin": "Screenshots are not enabled (Settings › Activity).",
    "screenshotsEnabled": "Allow screenshots",
    "settingsHint": "While a timer is running, the app sends location points – only with the consent of the person. Turning it off deletes all recorded locations.",
    "settingsTitle": "Location tracking",
    "tabs": {
      "apps": "Apps & websites",
      "locations": "Locations",
      "screenshots": "Screenshots"
    },
    "timeline": "Timeline",
    "topApps": "Most used",
    "trackingActive": "Location is being recorded",
    "trackingError": "Location unavailable: {{error}}",
    "untracked": "no timer"
  },
  "admin": {
    "active": "Active",
    "activeUsers": "active (30 days)",
    "activeWorkspaces": "active (30 days)",
    "addPlan": "Add plan",
    "billingMode": "Billing",
    "code": "Code",
    "configured": "configured",
    "created": "Created",
    "currency": "Currency",
    "days": "Days",
    "deleteWorkspace": "Delete workspace?",
    "deleteWorkspaceText": "\"{{name}}\" will be deleted for all members. This cannot be undone.",
    "deleted": "Deleted",
    "description": "Description",
    "editPlan": "Edit plan: {{name}}",
    "entriesToday": "Entries today",
    "extendTrial": "Extend trial",
    "extendTrialFor": "Extend trial: {{name}}",
    "failedEvents": "{{count}} failed event deliveries",
    "features": "Features",
    "forbidden": "Super admins only.",
    "impersonate": "Sign in as user",
    "impersonateHint": "For support cases. The reason and all actions are logged in the workspace audit log.",
    "impersonateTitle": "Sign in as {{name}}",
    "imports": "Recent imports",
    "inactive": "inactive",
    "instance": "Installation",
    "internal": "internal",
    "jobs": "Background jobs",
    "lastActivity": "Last activity",
    "lastLogin": "Last sign-in",
    "lock": "Lock",
    "locked": "Locked",
    "loginProviders": "Login providers",
    "mail": "Email delivery",
    "mailTest": "Send test email",
    "mailTestSent": "Test email sent to your address.",
    "maintenance": "Maintenance mode",
    "maintenanceHint": "Only super admins can use the app; everyone else sees the notice.",
    "maintenanceMessage": "Notice",
    "maxMembers": "Max. members",
    "members": "Members",
    "mrr": "MRR (net)",
    "notConfigured": "not configured",
    "owner": "Owner",
    "perSeat": "per seat/month",
    "perSeatPerMonth": "per seat/month when paid yearly",
    "periodEnd": "Valid until",
    "plan": "Plan",
    "planName": "Name",
    "priceMonthly": "Monthly price",
    "priceYearly": "Yearly price",
    "public": "Publicly bookable",
    "reason": "Reason",
    "reasonPlaceholder": "e.g. ticket #1234",
    "registration": "Registration",
    "registrationInvite": "Invitation only",
    "registrationOpen": "Open",
    "reset2fa": "Reset 2FA",
    "searchUsers": "Search name or email …",
    "searchWorkspaces": "Search workspace or owner …",
    "sessionTimeout": "Session timeout when idle",
    "setPlan": "Set plan",
    "setPlanFor": "Set plan: {{name}}",
    "setPlanHint": "Manual assignment without payment, e.g. for invoiced customers or goodwill.",
    "sortOrder": "Order",
    "status": "Status",
    "storage": "File storage",
    "subscriptions": "Subscriptions",
    "tabs": {
      "audit": "Audit log",
      "overview": "Overview",
      "plans": "Plans",
      "settings": "Settings",
      "users": "Users",
      "workspaces": "Workspaces"
    },
    "title": "Operator admin",
    "unlimitedHint": "empty = unlimited",
    "unlock": "Unlock",
    "users": "Users",
    "webhookFailures": "Failing webhooks",
    "workspaces": "Workspaces"
  },
  "apiKeys": {
    "copy": "Copy",
    "created": "New API key",
    "createdAt": "Created",
    "generate": "Generate key",
    "lastUsed": "Last used",
    "name": "Name",
    "onlyOnce": "The key is shown only once. Please copy it now.",
    "prefix": "Key",
    "text": "API keys let scripts and integrations access the REST API on your behalf (header \"Authorization: Bearer …\" or \"X-Api-Key\").",
    "title": "API keys"
  },
  "approvals": {
    "actions": {
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "SUBMITTED": "Submitted",
      "WITHDRAWN": "Withdrawn"
    },
    "allSubmitted": "All periods with tracked time have been submitted.",
    "approve": "Approve",
    "approveDirectly": "Approve directly",
    "billable": "Billable",
    "expenses": "Expenses",
    "history": "History",
    "noArchive": "No decided requests yet.",
    "noPending": "No pending requests.",
    "notSubmitted": "Not submitted",
    "period": "Period",
    "person": "Person",
    "reject": "Reject",
    "rejectReason": "Reason for rejection",
    "status": "Status",
    "statuses": {
      "APPROVED": "Approved",
      "REJECTED": "Rejected",
      "SUBMITTED": "Submitted",
      "WITHDRAWN": "Withdrawn"
    },
    "tabs": {
      "archive": "Archive",
      "pending": "Pending",
      "unsubmitted": "Not submitted"
    },
    "total": "Total",
    "withdraw": "Withdraw"
  },
  "attendance": {
    "absence": "Absence",
    "break": "Break",
    "capacity": "Capacity",
    "firstStart": "First start",
    "lastEnd": "Last stop",
    "overtime": "Overtime",
    "person": "Person",
    "work": "Work"
  },
  "audit": {
    "action": "Action",
    "actor": "Person",
    "after": "After",
    "before": "Before",
    "entity": "Object",
    "none": "No events in this period.",
    "searchPlaceholder": "Action, details or ID …",
    "summary": "Details",
    "system": "System",
    "time": "Time",
    "viaImpersonation": "via {{name}} (impersonation)",
    "workspace": "Workspace"
  },
  "banners": {
    "choosePlan": "Choose a plan",
    "impersonating": "You are acting as {{name}} (signed in as {{admin}}). All actions are logged.",
    "maintenanceAdmin": "Maintenance mode active: {{message}} – only super admins can make changes.",
    "pastDue": "The last payment failed. Please update your payment details so the workspace is not downgraded.",
    "stopImpersonation": "Stop impersonation",
    "toBilling": "Go to billing",
    "trialEnds_one": "The trial ends tomorrow.",
    "trialEnds_other": "The trial ends in {{count}} days.",
    "trialEnds_zero": "The trial ends today."
  },
  "billing": {
    "address": "Address",
    "cancelConfirm": "Cancel subscription",
    "cancelScheduled": "Cancelled as of {{date}} – {{plan}} applies afterwards.",
    "cancelText": "The plan stays active until the end of the paid period, then Free applies.",
    "cancelTitle": "Cancel subscription?",
    "changeConfirm": "Continue",
    "changeScheduled": "Change to {{plan}} scheduled for {{date}}.",
    "changeTextCheckout": "You will be redirected to secure payment with Mollie (credit card, SEPA direct debit, PayPal …).",
    "changeTextMandate": "Upgrades apply immediately and are charged pro rata; downgrades and period changes apply at the end of the period.",
    "changeTitle": "Switch to {{plan}}?",
    "checkoutDone": "Thank you! The payment is being processed – the plan will be activated shortly.",
    "choose": "Choose",
    "company": "Company / name",
    "country": "Country",
    "current": "Current plan",
    "currentPlan": "Current plan",
    "details": "Billing details",
    "downgrade": "Downgrade",
    "free": "Free",
    "inTrial": "in trial",
    "invoiceEmail": "Invoice email",
    "invoices": "Invoices",
    "mandateNo": "none",
    "mandateYes": "on file",
    "maxMembers": "up to {{count}} members",
    "moreFeatures": "… and {{count}} more",
    "noInvoices": "No invoices yet.",
    "ownerOnly": "Only the workspace owner can manage plan and billing.",
    "pastDue": "Payment failed. We will retry; without payment the workspace will be downgraded to Free on {{date}}.",
    "paymentMethod": "Payment method",
    "perSeatMonth": "per seat and month",
    "period": "Billing",
    "periodEnd": "Next billing",
    "periods": {
      "MONTHLY": "Monthly",
      "YEARLY": "Yearly"
    },
    "plans": "Plans",
    "providerMissing": "The payment provider is not configured yet. Please contact the operator.",
    "result": {
      "changed": "Plan changed.",
      "charged": "Upgrade to {{plan}} – the pro-rata amount is being charged.",
      "redirect": "Redirecting to payment …",
      "scheduled": "Change scheduled for the end of the period."
    },
    "reverseCharge": "Net prices; reverse charge applies.",
    "seats": "Seats",
    "selfHosted": "This installation runs without billing (self-hosted) – all features are enabled.",
    "status": {
      "ACTIVE": "Active",
      "CANCELED": "Canceled",
      "PAST_DUE": "Past due",
      "TRIALING": "Trial"
    },
    "taxNote": "Prices net plus {{rate}}% VAT.",
    "tooManyMembers": "Too many members",
    "totalMonthly": "{{amount}} / month for {{seats}} seats",
    "totalYearly": "{{amount}} / year for {{seats}} seats",
    "trialEnds": "Trial until",
    "undo": "Undo",
    "vatId": "VAT ID",
    "yearlyDiscount": "Yearly (cheaper)"
  },
  "branding": {
    "color": "Accent colour",
    "colorHint": "Colour bar in the header and login page",
    "domain": "Custom domain",
    "domainHint": "Point a CNAME to this installation; the reverse proxy handles TLS certificate and routing.",
    "loginLink": "Login link",
    "logo": "Logo",
    "logoHint": "PNG, JPEG or WebP, max. 512 KB. Shown in the header and on the login page.",
    "noLogo": "No logo uploaded.",
    "slug": "Slug",
    "slugHint": "For the login link with branding and SSO.",
    "slugHintSubdomain": "Sign in via {{url}}",
    "uploadLogo": "Upload logo"
  },
  "calendar": {
    "connect": "Connect calendars",
    "day": "Day",
    "hint": "Drag in the grid to create an entry. Entries can be moved and resized at the bottom edge; click to open details.",
    "newEntry": "New time entry",
    "openSource": "Open in source",
    "startTimer": "Start timer",
    "takeOver": "Add as entry",
    "today": "Today",
    "week": "Week"
  },
  "calendarIntegration": {
    "add": "Subscribe",
    "color": "Color",
    "externalText": "Events from Google, Outlook or other calendars appear in a lane next to your entries. Use the calendar's secret ICS address.",
    "externalTitle": "External calendars",
    "feedCreate": "Create feed address",
    "feedDisable": "Disable feed",
    "feedOnce": "The address is shown only now. Creating a new one invalidates the old one.",
    "feedRenew": "Create new address",
    "feedText": "Subscribe to your tracked time in Outlook, Google or Apple Calendar. The address is secret – anyone who has it can see your entries.",
    "feedTitle": "Personal calendar feed (ICS)",
    "name": "Name",
    "title": "Calendar integration",
    "url": "ICS address"
  },
  "clients": {
    "address": "Address",
    "create": "New client",
    "currency": "Currency",
    "deleteText": "Delete client \"{{name}}\"?",
    "deleteTitle": "Delete client",
    "edit": "Edit client",
    "email": "Email",
    "empty": "No clients.",
    "name": "Name",
    "note": "Note"
  },
  "comingSoon": {
    "description": "The feature is specified and will be built in the release phase shown.",
    "features": "Features: {{features}}",
    "phase": "Phase {{phase}}",
    "title": "This area is in progress"
  },
  "common": {
    "actions": "Actions",
    "apply": "Apply",
    "archive": "Archive",
    "archived": "Archived",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "copied": "Copied",
    "copy": "Copy",
    "create": "Create",
    "delete": "Delete",
    "done": "Done",
    "edit": "Edit",
    "emailPlaceholder": "name@company.com",
    "error": "Error",
    "me": "me",
    "more": "More actions",
    "next": "Next",
    "no": "No",
    "previous": "Previous",
    "remove": "Remove",
    "required": "Required",
    "restore": "Restore",
    "save": "Save",
    "saved": "Saved",
    "search": "Search",
    "teammates": "Teammates",
    "undo": "Undo",
    "yes": "Yes"
  },
  "customFields": {
    "activeInProject": "Active",
    "add": "Add field",
    "adminOnly": "Only admins can edit",
    "adminOnlyHint": "Others can see the value but cannot set it.",
    "allProjects": "Active for all projects",
    "allProjectsHint": "When off: only in projects where the field is enabled.",
    "defaultValue": "Default value",
    "deleteText": "\"{{name}}\" will be deleted. Values already recorded stay stored on the entries but are no longer shown.",
    "deleteTitle": "Delete field?",
    "edit": "Edit field",
    "entityTimeEntry": "Time entries",
    "entityUser": "Profile fields",
    "entryFields": "More fields",
    "entryHint": "Additional information on time entries – in the tracker, timesheet and reports (column, filter, grouping, export).",
    "filterField": "Field",
    "filterValue": "Value",
    "hidden": "Visible to admins only",
    "hiddenHint": "Hidden from everyone else (also in reports).",
    "name": "Name",
    "none": "No fields yet.",
    "noneForProjects": "There are no time entry fields yet (Settings › Fields).",
    "options": "Options",
    "optionsHint": "Press Enter to add",
    "overridden": "Project setting",
    "profileFields": "Profile fields",
    "projectDefault": "Project default",
    "properties": "Properties",
    "required": "Required",
    "reset": "Reset",
    "saveProfileFields": "Save profile fields",
    "selectedProjects": "Selected projects",
    "type": "Type",
    "types": {
      "CHECKBOX": "Checkbox",
      "LINK": "Link",
      "MULTI_SELECT": "Multi-select",
      "NUMBER": "Number",
      "SELECT": "Dropdown",
      "TEXT": "Text"
    },
    "userHint": "Custom information on members, e.g. personnel number or department."
  },
  "dashboard": {
    "lastActive": "Last active: {{when}}",
    "me": "Me",
    "noActivity": "No activity yet",
    "projects": "Projects",
    "team": "Team",
    "teamActivity": "Team activity",
    "topActivities": "Top activities"
  },
  "days": {
    "FRIDAY": "Fri",
    "MONDAY": "Mon",
    "SATURDAY": "Sat",
    "SUNDAY": "Sun",
    "THURSDAY": "Thu",
    "TUESDAY": "Tue",
    "WEDNESDAY": "Wed"
  },
  "entryTypes": {
    "BREAK": "Break",
    "HOLIDAY": "Holiday",
    "REGULAR": "Work",
    "TIME_OFF": "Time off"
  },
  "errors": {
    "breaks-disabled": "Breaks are disabled in this workspace.",
    "client-in-use": "The client still has projects. Please archive it.",
    "concurrent-modification": "The record was changed in the meantime. Please reload.",
    "domain-taken": "This domain is already taken.",
    "end-before-start": "The end is before the start.",
    "entry-exceeds-max": "The entry exceeds the maximum duration.",
    "feature-not-available": "This feature is not included in the current plan or disabled.",
    "forbidden": "You are not allowed to do this.",
    "future-entry": "Entries in the future are not allowed.",
    "integrity-violation": "The name is already taken.",
    "invalid-slug": "The slug is invalid or reserved.",
    "maintenance": "Maintenance – changes are not possible right now.",
    "no-running-timer": "No timer is running.",
    "project-in-use": "Time has already been tracked on this project. Please archive it.",
    "required-fields-missing": "Please fill in the required fields: {{fields}}",
    "seat-limit": "The plan member limit has been reached.",
    "slug-taken": "This slug is already taken.",
    "sso-domain-taken": "The domain is already assigned to another workspace.",
    "sso-required": "Single sign-on is required for this email address.",
    "tag-in-use": "The tag is in use. Please archive it.",
    "task-in-use": "Time has been tracked on this task. Please mark it as done.",
    "too-many-members": "The plan does not allow that many active members.",
    "two-factor-required": "This workspace requires two-factor authentication.",
    "workspace-locked": "The workspace is locked. Please contact support."
  },
  "expenses": {
    "add": "Add expense",
    "addCategory": "Add category",
    "amount": "Amount",
    "billing": "Billing",
    "byAmount": "By amount",
    "category": "Category",
    "chooseFile": "Choose file",
    "count": "Count",
    "date": "Date",
    "edit": "Edit expense",
    "editCategory": "Edit category",
    "empty": "No expenses in this period.",
    "noCategories": "No categories yet – an admin creates them under Expenses › Categories.",
    "note": "Note",
    "perUnit": "Bill per unit",
    "perUnitHint": "E.g. kilometres × mileage rate – the amount is calculated from the quantity.",
    "perUnitValue": "{{price}} per {{unit}}",
    "person": "Person",
    "quantity": "Quantity ({{unit}})",
    "receipt": "Receipt",
    "receiptsZip": "Receipts (ZIP)",
    "removeReceipt": "Remove receipt",
    "tabs": {
      "categories": "Categories",
      "list": "Expenses"
    },
    "takePhoto": "Take photo",
    "total": "Total",
    "unitName": "Unit",
    "unitPrice": "Price per unit"
  },
  "features": {
    "ACTIVITY": "Activity (GPS, screenshots)",
    "APPROVALS": "Approvals",
    "ATTENDANCE_REPORT": "Attendance report",
    "AUDIT_LOG": "Audit log",
    "BRANDING": "Branding & custom domain",
    "BREAKS": "Breaks",
    "BUDGETS": "Budgets & estimates",
    "BULK_EDIT": "Bulk edit",
    "CALENDAR": "Calendar",
    "COST_RATES": "Cost rates & profit",
    "CUSTOM_FIELDS": "Custom fields",
    "EXPENSES": "Expenses",
    "GPS": "GPS locations",
    "HISTORIC_RATES": "Historic rates",
    "IMPORT": "Import",
    "INVOICING": "Invoicing",
    "KIOSK": "Kiosk",
    "LOCK_ENTRIES": "Lock entries",
    "PROJECT_TEMPLATES": "Project templates",
    "REQUIRED_FIELDS": "Required fields",
    "SCHEDULED_REPORTS": "Scheduled reports",
    "SCHEDULING": "Scheduling",
    "SCREENSHOTS": "Screenshots & app tracking",
    "SSO": "Single sign-on & SCIM",
    "TEAM_MANAGERS": "Team managers",
    "TIMESHEET": "Timesheet",
    "TIME_FOR_OTHERS": "Track time for others",
    "TIME_OFF": "Time off",
    "USER_FIELDS": "Profile fields",
    "WEBHOOKS": "Webhooks"
  },
  "gates": {
    "maintenanceTitle": "Maintenance",
    "reload": "Reload",
    "twoFactorText": "This workspace requires two-factor authentication. Set it up here to continue – or switch workspace.",
    "twoFactorTitle": "Two-factor authentication required"
  },
  "header": {
    "admin": "Operator admin",
    "createWorkspace": "Create workspace",
    "help": "Help & API",
    "integrations": "Integrations",
    "logout": "Log out",
    "notifications": "Notifications",
    "profile": "Profile",
    "workspaceSettings": "Workspace settings",
    "workspaces": "Workspaces"
  },
  "import": {
    "apiKey": "Clockify API key",
    "chooseFile": "Choose CSV file",
    "clockifyHint": "The import runs in the background and can be repeated – data already imported is recognised and not duplicated. Members are created as invited accounts.",
    "clockifyText": "Imports members, groups, clients, tags, projects (incl. access, rates and estimates), tasks and time entries via the Clockify API.",
    "clockifyTitle": "Import from Clockify",
    "connect": "Connect",
    "counts": {
      "clients": "clients",
      "created": "created",
      "entriesCreated": "entries new",
      "entriesSkipped": "entries skipped",
      "entriesUpdated": "entries updated",
      "errors": "errors",
      "groups": "groups",
      "projects": "projects",
      "skipped": "skipped",
      "tags": "tags",
      "tasks": "tasks",
      "updated": "updated",
      "users": "users"
    },
    "csvText": "Columns are detected automatically (e.g. from Clockify, Toggl or Harvest exports) and can be adjusted. Missing projects, clients, tasks and tags are created.",
    "csvTitle": "Time entries from CSV",
    "entriesRange": "Time entries in range",
    "exportButton": "Download export",
    "exportText": "Downloads all data of this workspace as a ZIP archive of JSON files (e.g. for archiving or data requests).",
    "exportTitle": "Export workspace",
    "fields": {
      "BILLABLE": "Billable",
      "CLIENT": "Client",
      "DESCRIPTION": "Description",
      "DURATION": "Duration",
      "END_DATE": "End date",
      "END_DATETIME": "End (date + time)",
      "END_TIME": "End time",
      "PROJECT": "Project",
      "START_DATE": "Start date",
      "START_DATETIME": "Start (date + time)",
      "START_TIME": "Start time",
      "TAGS": "Tags",
      "TASK": "Task",
      "USER_EMAIL": "User email",
      "USER_NAME": "User name"
    },
    "history": "Previous imports",
    "importExpenses": "Import expenses (incl. categories)",
    "importGroups": "Import groups",
    "importInvoices": "Import invoices",
    "importRates": "Import hourly rates",
    "importSchedule": "Import schedule (assignments)",
    "importTimeOff": "Import time off (policies, holidays, requests)",
    "rowsFound": "{{count}} rows found",
    "run": "Import",
    "sourceWorkspace": "Clockify workspace",
    "start": "Start import",
    "status": {
      "CANCELED": "Canceled",
      "DONE": "Done",
      "FAILED": "Failed",
      "QUEUED": "Queued",
      "RUNNING": "Running"
    }
  },
  "invite": {
    "accept": "Accept invitation",
    "createAccount": "Create account and join",
    "invalid": "This invitation is invalid or has already been used.",
    "loginFirst": "Log in with an existing account",
    "text": "You have been invited to the workspace \"{{workspace}}\".",
    "title": "Invitation"
  },
  "invoices": {
    "addItem": "Add item",
    "addPayment": "Record payment",
    "amount": "Amount",
    "bankName": "Bank",
    "client": "Client",
    "clientAddress": "Address",
    "clientEmail": "Client email",
    "companyAddress": "Address",
    "companyEmail": "Email",
    "companyName": "Company",
    "create": "Create invoice",
    "defaultNote": "Default note",
    "description": "Description",
    "discount": "Discount",
    "dueDate": "Due date",
    "dueDays": "Payment term (days)",
    "empty": "No invoices yet.",
    "filters": {
      "all": "All",
      "open": "Open"
    },
    "footer": "Footer",
    "grouping": "Grouping",
    "groupings": {
      "ENTRY": "Per entry",
      "PROJECT": "Per project",
      "TASK": "Per task",
      "USER": "Per person"
    },
    "import": "Import",
    "importHint": "Imports uninvoiced billable time of this client's projects and marks it as invoiced.",
    "importTime": "Import time",
    "includeExpenses": "Import billable expenses",
    "includeTime": "Import time",
    "issueDate": "Invoice date",
    "items": "Line items",
    "locale": "Invoice language",
    "markSent": "Mark as sent",
    "message": "Message",
    "messagePlaceholder": "Optional – a default text is used otherwise",
    "noItems": "No line items yet.",
    "note": "Note on invoice",
    "number": "Number",
    "outstanding": "Outstanding",
    "padding": "Digits",
    "payment": "Payment",
    "prefix": "Prefix",
    "publicLink": "Public link",
    "quantity": "Quantity",
    "recipient": "Recipient",
    "remaining": "Remaining",
    "saveItems": "Save line items",
    "send": "Send",
    "settings": "Settings",
    "status": "Status",
    "statuses": {
      "DRAFT": "Draft",
      "OVERDUE": "Overdue",
      "PAID": "Paid",
      "PARTIALLY_PAID": "Partially paid",
      "SENT": "Sent",
      "VOID": "Void"
    },
    "subject": "Subject",
    "subtotal": "Subtotal",
    "tax1Name": "Tax",
    "tax1Rate": "Tax rate",
    "tax2Name": "2nd tax",
    "tax2Rate": "2nd tax rate",
    "taxId": "VAT ID",
    "timeItem": "{{count}} time entries",
    "total": "Total",
    "unitPrice": "Unit price",
    "void": "Void",
    "voidText": "The invoice will be voided; the number is kept and invoiced time becomes billable again."
  },
  "kiosk": {
    "allMembers": "All members",
    "allowedGroups": "Allowed groups",
    "allowedPeople": "Allowed people",
    "back": "Back",
    "backspace": "Delete",
    "breakEnd": "End break",
    "breakStart": "Start break",
    "breakToday": "Break today",
    "breakTotal": "Break: {{duration}}",
    "breaksAllowed": "Allow breaks",
    "clockIn": "Clock in",
    "clockInInto": "Clock in to {{name}}",
    "clockOut": "Clock out",
    "copyLink": "Copy link",
    "create": "Create kiosk",
    "defaultDeviceName": "Tablet",
    "defaultProject": "Default project",
    "deleteText": "Delete kiosk \"{{name}}\"? Paired devices will stop working.",
    "deleteTitle": "Delete kiosk",
    "deviceName": "Device name",
    "devices": "Devices",
    "devicesHint": "Unpaired devices must be paired again via the kiosk link.",
    "devicesOf": "Devices of \"{{name}}\"",
    "done": {
      "BREAK_END": "Break ended – back to work!",
      "BREAK_START": "Break started – enjoy!",
      "CLOCK_IN": "Clocked in – have a good day!",
      "CLOCK_OUT": "Clocked out – see you soon!",
      "SWITCH_PROJECT": "Project switched"
    },
    "edit": "Edit kiosk",
    "empty": "No kiosks yet.",
    "enterPin": "Enter PIN",
    "fullscreen": "Fullscreen",
    "generatePin": "Generate PIN",
    "generatedPin": "New PIN (visible only now):",
    "invalidLink": "The kiosk link is invalid or has been renewed.",
    "lastSeen": "Last active: {{time}}",
    "link": "Kiosk link",
    "listHint": "A kiosk is a time clock, e.g. a tablet at the entrance. Open the kiosk link once on the device to pair it.",
    "name": "Name",
    "namePlaceholder": "e.g. Branch West",
    "newPin": "New PIN (4–6 digits)",
    "noDevices": "No devices paired yet.",
    "noPin": "No PIN has been set for you yet. Set one in your profile or ask your admin.",
    "open": "Open",
    "pair": "Pair",
    "pairText": "This device will be set up as a time clock for the kiosk. No login is required afterwards.",
    "pairTitle": "Pair device",
    "people": "People",
    "person": "Person",
    "pinLength": "PIN length",
    "pinLocked": "Too many failed attempts. Please try again in a few minutes.",
    "pinNotSet": "No PIN",
    "pinSaved": "PIN saved",
    "pinSet": "PIN set",
    "pinText": "Use this PIN to clock in and out at the kiosks of \"{{workspace}}\".",
    "pinTitle": "Kiosk PIN",
    "presence": {
      "BREAK": "On break",
      "IN": "Clocked in",
      "OUT": "Clocked out"
    },
    "projectSwitchAllowed": "Allow project switching",
    "regenerateLink": "Create new link",
    "revoke": "Unpair",
    "revoked": "This device was unpaired. Please pair it again.",
    "searchPerson": "Search name",
    "selectedCount": "{{count}} selected",
    "since": "Since {{time}} ({{duration}})",
    "sinceColumn": "Since",
    "status": "Status",
    "switchProject": "Switch project",
    "tabs": {
      "attendance": "Who is in",
      "kiosks": "Kiosks"
    },
    "timeout": "Automatic logout after",
    "today": "Today",
    "unavailable": "The kiosk is not available.",
    "week": "This week",
    "workToday": "Work today",
    "workingOn": "Current: {{name}}",
    "wrongPin": "Wrong PIN."
  },
  "legal": {
    "imprint": "Legal notice",
    "privacy": "Privacy",
    "terms": "Terms"
  },
  "login": {
    "accountDeleted": "Your account has been deleted.",
    "accountLocked": "Your account is locked.",
    "backendUnavailable": "Server unavailable",
    "code": "Code",
    "continueWith": "Continue with {{provider}}",
    "email": "Email",
    "forgotPassword": "Forgot password?",
    "invalidCode": "The code is invalid.",
    "invalidCredentials": "Email or password is incorrect.",
    "invalidEmail": "Please enter a valid email address.",
    "maintenance": "Maintenance: {{message}}",
    "memberInactive": "Your membership in this workspace is deactivated.",
    "noAccount": "No account yet?",
    "oauthEmailError": "The provider did not return a verified email address.",
    "oauthError": "Signing in with the external provider failed.",
    "oauthTerms": "If you sign up via a provider, the <terms>terms and conditions</terms> and the <privacy>privacy policy</privacy> apply.",
    "or": "or",
    "password": "Password",
    "passwordRequired": "Please enter your password.",
    "recoveryCode": "Recovery code",
    "recoveryHint": "Enter one of your recovery codes. Each code works only once.",
    "register": "Sign up",
    "registrationClosed": "New accounts can currently only be created by invitation.",
    "sso": "Sign in with single sign-on",
    "ssoDisabled": "Single sign-on is not active for this workspace.",
    "ssoEmailUnverified": "Your email address is not verified at the identity provider.",
    "ssoError": "Sign-in via the identity provider failed.",
    "ssoExpired": "The sign-in has expired. Please try again.",
    "ssoNotProvisioned": "Your account is not a member of this workspace. Please contact the admin.",
    "ssoRequired": "Single sign-on is required for this email address.",
    "ssoWith": "Continue with SSO ({{name}})",
    "submit": "Log in",
    "title": "Log in",
    "tooManyAttempts": "Too many failed attempts. Please try again in 15 minutes.",
    "twoFactorHint": "Enter the 6-digit code from your authenticator app.",
    "twoFactorTitle": "Two-step verification",
    "useApp": "Use code from app",
    "usePassword": "Sign in with password instead",
    "useRecovery": "Use a recovery code",
    "verify": "Verify",
    "version": "Firetracker {{version}}"
  },
  "nav": {
    "groups": {
      "analyze": "Analyze",
      "manage": "Manage",
      "track": "Track"
    },
    "items": {
      "activity": "Activity",
      "approvals": "Approvals",
      "billing": "Plan & billing",
      "calendar": "Calendar",
      "clients": "Clients",
      "dashboard": "Dashboard",
      "expenses": "Expenses",
      "invoices": "Invoices",
      "kiosks": "Kiosks",
      "projects": "Projects",
      "reports": "Reports",
      "schedule": "Schedule",
      "settings": "Settings",
      "tags": "Tags",
      "team": "Team",
      "timeOff": "Time off",
      "timesheet": "Timesheet",
      "tracker": "Time Tracker"
    },
    "label": "Main navigation",
    "toggle": "Toggle navigation"
  },
  "notFound": {
    "back": "Back to start",
    "description": "The requested page does not exist.",
    "title": "Page not found"
  },
  "notifications": {
    "email": "Email",
    "empty": "No notifications",
    "inApp": "In app",
    "markAllRead": "Mark all as read",
    "push": "Push",
    "pushActive": "Push is active on this device ({{count}} device(s) in total).",
    "pushDenied": "Notifications are blocked in the browser.",
    "pushDisable": "Disable",
    "pushEnable": "Enable push on this device",
    "pushInactive": "Push notifications are not active on this device.",
    "pushSent": "Test notification sent",
    "pushTest": "Send test",
    "pushUnsupported": "This browser does not support push notifications (on iOS: add the app to the home screen).",
    "settingsText": "Choose what you are notified about and how.",
    "settingsTitle": "Notifications",
    "types": {
      "APPROVAL_DECIDED": "Timesheet approved/rejected",
      "APPROVAL_REMINDER": "Reminder: submit timesheet",
      "APPROVAL_SUBMITTED": "Timesheet submitted",
      "BILLING": "Billing & plan",
      "BUDGET_ALERT": "Budget alert",
      "EMAIL_VERIFICATION": "Email verification",
      "IMPORT_FINISHED": "Import finished",
      "INVITATION": "Invitations",
      "INVOICE_SENT": "Invoice sent",
      "LOW_HOURS_REMINDER": "Reminder: too little time tracked",
      "PASSWORD_RESET": "Password reset",
      "SCHEDULED_REPORT": "Scheduled report",
      "SCHEDULE_PUBLISHED": "Schedule published",
      "TIMER_AUTO_STOPPED": "Timer stopped automatically",
      "TIMER_RUNNING_LONG": "Timer running long",
      "TIME_OFF_DECIDED": "Time off decided",
      "TIME_OFF_REQUESTED": "Time off requested",
      "WEEKLY_SUMMARY": "Weekly summary"
    }
  },
  "offline": {
    "conflictTitle": "{{count}} offline change(s) could not be applied",
    "hint": "No connection. Timer and entries are saved and synced later.",
    "offline": "Offline",
    "offlinePending": "Offline · {{count}} pending",
    "pending": "Syncing {{count}} change(s)",
    "syncing": "Changes made offline are being synced."
  },
  "passwordReset": {
    "backToLogin": "Back to login",
    "done": "Your password has been changed. You can log in now.",
    "hint": "We will send you a link to set a new password.",
    "invalid": "The link is invalid or has expired.",
    "newTitle": "Set a new password",
    "send": "Send link",
    "sent": "If an account exists for this address, an email is on its way.",
    "title": "Reset password"
  },
  "picker": {
    "create": "Create project",
    "createNamed": "Create project \"{{name}}\"",
    "createTag": "Create tag \"{{name}}\"",
    "empty": "No projects",
    "favorites": "Favorites",
    "noProject": "No project",
    "noTags": "No tags",
    "project": "Project",
    "search": "Search project, task or client",
    "searchTags": "Search tags",
    "showTasks": "Show tasks",
    "tags": "Tags",
    "withoutClient": "Without client"
  },
  "privacy": {
    "delete": "Delete account",
    "deleteConfirm": "Delete permanently",
    "deleteText": "Your account will be anonymised and you will be signed out. Workspaces where you are the only user will be deleted. If you own workspaces with other members, transfer ownership first.",
    "deleteTitle": "Delete account permanently?",
    "export": "Export my data",
    "exportHint": "Download all data stored for your account as a ZIP (JSON files, GDPR Art. 15/20).",
    "title": "Privacy"
  },
  "profile": {
    "changePassword": "Change password",
    "currentPassword": "Current password",
    "dateFormat": "Date format",
    "decimal": "Decimal (1.50)",
    "durationFormat": "Duration format",
    "groupSimilar": "Group similar entries",
    "language": "Language",
    "newPassword": "New password",
    "passwordChanged": "Password changed",
    "preferences": "Preferences",
    "theme": "Theme",
    "themeDark": "Dark",
    "themeLight": "Light",
    "themeSystem": "System",
    "timeFormat": "Time format",
    "timesheetStart": "Default start time in timesheet",
    "timezone": "Time zone",
    "title": "Profile",
    "weekStart": "Week starts on"
  },
  "projects": {
    "access": "Access",
    "addMember": "Add member or group …",
    "addTask": "Add task",
    "alertPercent": "Alert at",
    "allClients": "All clients",
    "assignees": "Assignees",
    "billable": "Billable",
    "budget": "Budget",
    "budgetProgress": "Budget",
    "byMember": "By member",
    "byTask": "By task",
    "client": "Client",
    "color": "Color",
    "copy": "copy",
    "create": "New project",
    "deleteText": "Permanently delete project \"{{name}}\"? Projects with tracked time can only be archived.",
    "deleteTitle": "Delete project",
    "done": "Done",
    "duplicate": "Duplicate",
    "edit": "Edit project",
    "empty": "No projects found.",
    "estimate": "Estimate",
    "estimateHours": "Estimate (h)",
    "estimateProgress": "Estimate",
    "everyone": "Everyone",
    "favorite": "Favorite",
    "fixedFee": "Fixed fee",
    "fixedFeeHint": "Fixed fee {{fee}}, cost so far {{cost}}",
    "fixedFeeResult": "Fixed fee result (fee − cost)",
    "fromTasks": "Sum of tasks",
    "fromTemplate": "Create from template",
    "includeExpenses": "Include expenses in budget",
    "includesExpenses": "incl. expenses: {{amount}}",
    "makePrivate": "Make private",
    "makePublic": "Make public",
    "manager": "Project manager",
    "manual": "Manual (total)",
    "markDone": "Mark as done",
    "member": "Member / group",
    "membersPublicHint": "Public project: people added here can become project managers or get their own rates.",
    "monthly": "Monthly",
    "name": "Name",
    "never": "Never",
    "noClient": "No client",
    "noTasks": "No tasks",
    "none": "None",
    "notePlaceholder": "Project notes …",
    "onlyAssigneesTrack": "Only assignees can track time on tasks",
    "private": "Private",
    "privateHint": "Only added members and groups can see the project.",
    "public": "Public",
    "publicHint": "All workspace members can see the project.",
    "reopen": "Reopen",
    "resetPeriod": "Reset",
    "saveAsTemplate": "Save as template",
    "showArchived": "Show archived",
    "showDone": "Show done",
    "showTemplates": "Show templates",
    "tabs": {
      "access": "Access",
      "budget": "Budget & estimate",
      "fields": "Fields",
      "note": "Note",
      "rates": "Rates",
      "status": "Status",
      "tasks": "Tasks"
    },
    "taskName": "Task",
    "template": "Template",
    "thisMonth": "this month",
    "withoutTask": "Without task"
  },
  "pwa": {
    "reload": "Reload",
    "updateText": "Reload now to use it.",
    "updateTitle": "New version available"
  },
  "range": {
    "custom": "Custom …",
    "last2Weeks": "Last 2 weeks",
    "lastMonth": "Last month",
    "lastWeek": "Last week",
    "lastYear": "Last year",
    "next": "Next period",
    "previous": "Previous period",
    "thisMonth": "This month",
    "thisWeek": "This week",
    "thisYear": "This year",
    "today": "Today",
    "yesterday": "Yesterday"
  },
  "rates": {
    "allTime": "All entries",
    "billableRate": "Billable rate",
    "costRate": "Cost rate",
    "inherited": "inherited",
    "projectRate": "Project rate",
    "projectRateHint": "Applies to all entries of the project unless a more specific rate (member in project, task) is set.",
    "validFrom": "Valid from …",
    "validFromHint": "From which date does the new rate apply? Empty = all entries.",
    "workspaceDefault": "Workspace rate",
    "workspaceRate": "Default billable rate",
    "workspaceRateHint": "Applies to all entries without a more specific rate (member, project, task)."
  },
  "register": {
    "acceptTerms": "I agree to the <terms>terms and conditions</terms> and have read the <privacy>privacy policy</privacy>.",
    "closed": "Registration is closed – new accounts by invitation only.",
    "emailTaken": "An account with this email already exists.",
    "haveAccount": "Already have an account?",
    "invitedTo": "You have been invited to the workspace \"{{workspace}}\".",
    "name": "Name",
    "nameRequired": "Please enter your name.",
    "passwordHint": "At least 8 characters",
    "passwordTooShort": "At least 8 characters.",
    "submit": "Create account",
    "termsRequired": "Please accept the terms and conditions.",
    "title": "Create account"
  },
  "reports": {
    "amount": "Amount",
    "amountDisplay": "Amount display",
    "amountModes": {
      "amount": "Earned",
      "cost": "Cost",
      "hide": "Hide amounts",
      "profit": "Profit"
    },
    "assignments": "Planned vs. tracked",
    "attendance": "Attendance",
    "audit": "Audit log",
    "billable": "Billable",
    "copyLink": "Copy link",
    "detailed": "Detailed",
    "dim": {
      "BILLABILITY": "Billability",
      "CLIENT": "Client",
      "CUSTOM_FIELD": "Field",
      "DATE": "Date",
      "DESCRIPTION": "Description",
      "MONTH": "Month",
      "OVERTIME": "Overtime",
      "PROJECT": "Project",
      "TAG": "Tag",
      "TASK": "Task",
      "TYPE": "Type",
      "USER": "Member",
      "WEEK": "Week"
    },
    "duration": "Duration",
    "editShared": "Edit saved report",
    "expand": "Expand/collapse",
    "expenses": "Expenses",
    "export": "Export",
    "filter": {
      "all": "All",
      "approval": "Approval status",
      "approvalNone": "Not submitted",
      "noOvertime": "Without overtime",
      "notInvoiced": "Not invoiced",
      "overtimeOnly": "Overtime only",
      "reset": "Reset",
      "tagAll": "contains all",
      "tagAny": "contains any",
      "tagMode": "Tag logic",
      "tagNone": "contains none",
      "team": "Team"
    },
    "groupBy": "Group by",
    "noData": "No data in the selected period.",
    "noDescription": "(no description)",
    "noSaved": "No saved reports yet. Use \"Export → Save & share\" in a report.",
    "none": "(none)",
    "openPublic": "Open public view",
    "print": "Print",
    "profit": "Profit",
    "projectUser": "Project / member",
    "publicWarning": "Anyone with the link can view this report without logging in (including amounts, if visible).",
    "rangeMode": "Date range",
    "rangeModes": {
      "FIXED": "Fixed range (as selected)",
      "LAST_30_DAYS": "Last 30 days",
      "LAST_MONTH": "Last month",
      "LAST_WEEK": "Last week",
      "LAST_YEAR": "Last year",
      "THIS_MONTH": "This month",
      "THIS_WEEK": "This week",
      "THIS_YEAR": "This year"
    },
    "recipients": "Recipients",
    "recipientsHint": "Email addresses, confirm with Enter",
    "regularTime": "Regular time",
    "reportName": "Name",
    "roundDown": "Round down",
    "roundNearest": "To nearest",
    "roundUp": "Round up",
    "rounding": "Rounding",
    "roundingEnabled": "Round times",
    "roundingMinutes": "To minutes",
    "roundingMode": "Direction",
    "saveShare": "Save & share",
    "saved": "Saved",
    "schedule": "Send by email",
    "schedules": {
      "DAILY": "Daily",
      "MONTHLY": "Monthly (on the 1st)",
      "NONE": "Never",
      "WEEKLY": "Weekly (Mondays)"
    },
    "segment": {
      "BILLABILITY": "Billability",
      "CLIENT": "Client",
      "PROJECT": "Project",
      "USER": "Member"
    },
    "segmentation": "Split chart by",
    "sharedNotFound": "This report does not exist or is no longer shared.",
    "sharedVia": "Shared report",
    "subscriptions": "Subscriptions",
    "summary": "Summary",
    "title": "Title",
    "total": "Total",
    "type": "Type",
    "user": "User",
    "userProject": "Member / project",
    "visibility": "Visibility",
    "visibilityPublic": "Public via link",
    "visibilityWorkspace": "Workspace members",
    "week": "Week",
    "weekly": "Weekly",
    "weeklyTooLong": "The weekly report covers at most 62 days."
  },
  "schedule": {
    "addAssignment": "Add assignment",
    "addMilestone": "Milestone",
    "copyNextWeek": "Copy to next week",
    "day": "day",
    "deleteSeries": "Delete this and following in series",
    "deviation": "Deviation",
    "draft": "Draft",
    "editAssignment": "Edit assignment",
    "everyWeeks": "Every … weeks",
    "hint": "Drag to move, drag the right edge to extend, right-click to copy/split, double-click a day to create.",
    "hoursPerDay": "Hours per day",
    "includeNonWorking": "Include non-working days",
    "legendFull": "at capacity",
    "legendOver": "over capacity",
    "legendUnder": "under capacity",
    "loadTooltip": "Planned {{planned}} of {{capacity}}",
    "milestoneName": "Milestone",
    "noPeople": "No people visible.",
    "noProjects": "No planned projects in this period.",
    "note": "Note",
    "period": "Period",
    "person": "Person",
    "placeholder": "Placeholder",
    "placeholderHint": "E.g. \"Designer\" – assign to a person later.",
    "placeholderName": "Placeholder name",
    "planned": "Planned",
    "plannedHours": "Planned: {{hours}} h",
    "plannedToday": "Planned today",
    "plannedVsTracked": "Tracked / planned",
    "publish_one": "Publish ({{count}})",
    "publish_other": "Publish ({{count}})",
    "published_one": "{{count}} assignment published.",
    "published_other": "{{count}} assignments published.",
    "repeat": "Repeat",
    "repeatUntil": "Until",
    "splitAt": "Split on {{date}}",
    "startTimer": "Start timer",
    "tabs": {
      "projects": "Projects",
      "team": "Team"
    },
    "tracked": "Tracked",
    "weeks_one": "{{count}} week",
    "weeks_other": "{{count}} weeks"
  },
  "security": {
    "activate": "Activate",
    "copyCodes": "Copy codes",
    "disable": "Disable two-factor authentication",
    "emailNotVerified": "Your email address is not verified yet.",
    "enabled": "2FA enabled",
    "qrAlt": "QR code for the authenticator app",
    "recoveryText": "Store these codes safely. Each code lets you log in once if you lose access to your app. They are shown only now.",
    "recoveryTitle": "Recovery codes",
    "resend": "Resend verification",
    "scanHint": "Scan the QR code with your app and enter the code shown.",
    "setup": "Set up two-factor authentication",
    "title": "Security",
    "twoFactorText": "Protect your account with an authenticator app (e.g. Google Authenticator, 1Password, Authy).",
    "verificationSent": "Verification email sent."
  },
  "securitySettings": {
    "acsUrl": "ACS URL",
    "active": "Active",
    "autoProvision": "Provision members automatically",
    "autoProvisionHint": "People who sign in successfully become members (counts as a seat). Off: invited people only.",
    "certificate": "Identity provider signing certificate",
    "certificateHint": "PEM or Base64 (X.509)",
    "clientId": "Client ID",
    "clientSecret": "Client secret",
    "createToken": "Create token",
    "domains": "Email domains",
    "domainsHint": "For these domains the login page automatically offers SSO.",
    "enabled": "Enable SSO",
    "enforce": "Enforce SSO",
    "enforceHint": "Block password sign-in for addresses of these domains. The workspace owner can still sign in with a password.",
    "idpEntityId": "Identity provider entity ID",
    "inactive": "Inactive",
    "issuer": "Issuer URL",
    "loginUrl": "Direct login link",
    "metadata": "Download SP metadata",
    "oidcHint": "Create a web application at your identity provider (e.g. Entra ID, Google Workspace, Okta, Keycloak) and enter this redirect URI.",
    "ownNo2fa": "You have not set up 2FA yourself yet – you need to do so in your profile before you can continue.",
    "ownerFallback": "Tip: test the sign-in in a private window before enforcing SSO.",
    "redirectUri": "Redirect URI",
    "require2fa": "Require two-factor authentication for all members",
    "require2faHint": "Members without 2FA can only use the workspace after setting it up. Sign-ins via SSO count as fulfilled.",
    "revokeToken": "Revoke",
    "rotate": "Generate new token",
    "rotateText": "The previous token becomes invalid immediately. Enter the new token at your identity provider.",
    "rotateTitle": "Generate new SCIM token?",
    "samlHint": "Create a SAML application at your identity provider (or import the metadata). The assertion must be signed; the email address is read from NameID or the \"email\" attribute.",
    "scimBaseUrl": "SCIM base URL",
    "scimHint": "The identity provider creates members and groups automatically and deactivates them when they leave.",
    "scimTitle": "User provisioning (SCIM 2.0)",
    "secretKept": "stored – leave empty to keep it",
    "spEntityId": "Entity ID (service provider)",
    "ssoNotInPlan": "Single sign-on (OIDC/SAML) and SCIM are not included in the current plan.",
    "ssoTitle": "Single sign-on",
    "ssoUrl": "SSO URL (HTTP redirect)",
    "tokenOnce": "The token is shown only now. Copy it and enter it at your identity provider as a bearer token.",
    "tokenTitle": "SCIM token",
    "twoFactorTitle": "Two-factor authentication"
  },
  "sessions": {
    "current": "This session",
    "device": "Device",
    "ip": "IP address",
    "lastActive": "Last active",
    "revoke": "Sign out",
    "revokeOthers": "Sign out all others",
    "since": "signed in since {{date}}",
    "title": "Active sessions"
  },
  "settings": {
    "approvalPeriod": "Approval period",
    "approvalPeriods": {
      "MONTHLY": "Monthly",
      "SEMI_MONTHLY": "Semi-monthly",
      "WEEKLY": "Weekly"
    },
    "approvals": "Approvals",
    "approvalsIncludeExpenses": "Include expenses in approvals (locked with the period)",
    "audience": {
      "ADMINS": "Admins only",
      "EVERYONE": "Everyone",
      "MANAGERS": "Admins and managers"
    },
    "autoStopHours": "Automatically stop timer after (h)",
    "breaksEnabled": "Allow tracking breaks",
    "currency": "Currency",
    "currentPlan": "Current plan",
    "defaultBillable": "New entries without project are billable",
    "deleteWorkspace": "Delete workspace",
    "deleteWorkspaceConfirm": "Really delete workspace \"{{name}}\"?",
    "deleteWorkspaceHint": "The workspace becomes inaccessible for all members.",
    "emptyNoLimit": "Empty = no limit",
    "everyoneSeesAllReports": "All members can see all reports",
    "everyoneSeesTeamDashboard": "All members can see the team dashboard",
    "forbidFuture": "Forbid entries in the future",
    "integrationsHint": "Integrations (webhooks, API keys, calendars) follow in the next phases. The REST API is already documented at /swagger-ui.html.",
    "lockBefore": "Locked before",
    "lockDays": "Days",
    "lockEntries": "Lock entries",
    "lockFixed": "Before a fixed date",
    "lockNone": "No lock",
    "lockRolling": "Older than N days",
    "maxEntryHours": "Maximum entry duration (h)",
    "notInPlan": "Not in current plan",
    "overtimeTagging": "Tag overtime automatically",
    "overtimeTaggingHint": "Entries that exceed the daily capacity are tagged as \"Overtime\".",
    "projectManagersApprove": "Project managers approve time on their projects",
    "requiredFields": "Required fields",
    "tabs": {
      "activity": "Activity",
      "branding": "Branding",
      "fields": "Fields",
      "general": "General",
      "import": "Import & export",
      "integrations": "Integrations",
      "modules": "Modules & plan",
      "permissions": "Permissions",
      "security": "Security",
      "tracking": "Time tracking"
    },
    "task": "Task",
    "teamManagersApprove": "Team managers approve their team's time",
    "whoCreatesClients": "Who can create clients?",
    "whoCreatesProjects": "Who can create projects?",
    "whoCreatesTags": "Who can create tags?",
    "whoCreatesTasks": "Who can create tasks?",
    "whoSeesAmounts": "Who can see rates and amounts?"
  },
  "subscriptions": {
    "active": "Active",
    "edit": "Edit subscription",
    "empty": "No subscriptions yet. Subscribe to a report via \"Export\" in the summary, detailed or weekly report.",
    "format": "Format",
    "frequencies": {
      "DAILY": "Daily",
      "MONTHLY": "Monthly (on the 1st)",
      "WEEKLY": "Weekly (Mondays)"
    },
    "frequency": "Frequency",
    "hint": "Delivered at 7 am in your time zone with the creator’s permissions.",
    "lastRun": "Last sent",
    "me": "me",
    "name": "Name",
    "nextRun": "Next delivery",
    "paused": "paused",
    "periodHint": {
      "DAILY": "Contains the previous day.",
      "MONTHLY": "Contains the previous month.",
      "WEEKLY": "Contains the previous week (Mon–Sun)."
    },
    "recipients": "Recipients",
    "recipientsHint": "You always receive the report; add more addresses with Enter.",
    "reportType": "Report: {{type}} with the current filters",
    "sendNow": "Send now",
    "sent": "Report has been sent.",
    "subscribe": "Subscribe by email …"
  },
  "tags": {
    "create": "Create tag",
    "empty": "No tags.",
    "name": "New tag"
  },
  "team": {
    "active": "Active",
    "alreadyMembers": "All addresses are already members.",
    "cancelInvitation": "Cancel invitation",
    "capacity": "Capacity/day",
    "capacityPerDay": "Target hours per working day",
    "copyLink": "Copy link",
    "createGroup": "Create group",
    "deactivate": "Deactivate",
    "editGroup": "Edit group",
    "emails": "Email addresses",
    "emailsHint": "Separate multiple addresses with commas, semicolons or line breaks.",
    "group": "Group",
    "groupName": "Group name",
    "groups": "Groups",
    "inactive": "Inactive",
    "invitationLinks": "Invitation links (share them with the people; email delivery follows in phase 2):",
    "invitationResent": "Invitation resent to {{email}}.",
    "invite": "Invite members",
    "invited": "Invited",
    "managesGroups": "Manages groups",
    "managesMembers": "Manages members",
    "members": "Members",
    "name": "Name",
    "removeText": "Really remove \"{{name}}\"? Tracked data is kept.",
    "resendInvitation": "Resend invitation",
    "role": "Role",
    "roles": {
      "ADMIN": "Admin",
      "OWNER": "Owner",
      "TEAM_MANAGER": "Team manager",
      "USER": "Member"
    },
    "sendInvitations": "Invite",
    "transferOwnership": "Transfer ownership",
    "transferTo": "Transfer to {{name}}",
    "workingDays": "Working days"
  },
  "timeOff": {
    "accrual": "Entitlement",
    "accrualTypes": {
      "ACCRUAL": "Accrued monthly",
      "FIXED": "Fixed per year",
      "UNLIMITED": "Unlimited"
    },
    "adjust": "Adjust",
    "adjustAmount": "Adjustment",
    "adjustHint": "Positive = additional balance, negative = deduction",
    "adjustments": "Adjustments",
    "amount": "Amount",
    "approval": "Approval",
    "approvers": "Additional approvers",
    "approversHint": "Admins and the person's team managers can always approve.",
    "available": "available",
    "availableShort": "Available: {{value}}",
    "balance": "Balance",
    "carryover": "Carryover",
    "carryoverExpiry": "Carryover expires after (months)",
    "carryoverHint": "Empty = no carryover",
    "carryoverMax": "Max. carryover to next year",
    "country": "Country",
    "createEntries": "Create time entries for approved time off",
    "createHoliday": "Create holiday",
    "createHolidayEntries": "Create time entries for holidays",
    "createPolicy": "Create policy",
    "daysShort": "days",
    "daysValue": "{{value}} days",
    "editPolicy": "Edit policy",
    "effectiveDate": "Effective date",
    "entitlement": "Entitlement",
    "entitlementHint": "Annual entitlement or accrued entitlement so far",
    "firstHalf": "First half",
    "fullDay": "Full day",
    "halfDay": "Day portion",
    "halfDaysAllowed": "Allow half days",
    "holidayName": "Name",
    "hours": "Hours",
    "hoursValue": "{{value}} h",
    "import": "Import",
    "importHolidays": "Import public holidays",
    "myRequests": "My requests",
    "nationwide": "Nationwide",
    "negativeAllowed": "Allow negative balance",
    "noHolidays": "No holidays yet.",
    "noPending": "No pending requests.",
    "noPolicies": "No time off policy has been set up for you.",
    "noReport": "No balances.",
    "noRequests": "No requests yet.",
    "note": "Note",
    "onlyGroups": "Only for groups",
    "onlyGroupsHint": "Empty = applies to everyone",
    "pending": "Pending",
    "perYear": "Per year",
    "period": "Period",
    "person": "Person",
    "policy": "Policy",
    "policyName": "Name",
    "record": "Record",
    "recurring": "Yearly",
    "region": "State/canton",
    "request": "Request time off",
    "requiresApproval": "Requires approval",
    "restricted": "Groups only",
    "secondHalf": "Second half",
    "status": "Status",
    "statuses": {
      "APPROVED": "Approved",
      "PENDING": "Pending",
      "REJECTED": "Rejected",
      "WITHDRAWN": "Withdrawn"
    },
    "submitRequest": "Submit request",
    "tabs": {
      "approvals": "Approvals",
      "holidays": "Holidays",
      "overview": "Overview",
      "policies": "Policies",
      "report": "Balances",
      "timeline": "Team calendar"
    },
    "unit": "Unit",
    "units": {
      "DAYS": "Days",
      "HOURS": "Hours"
    },
    "used": "Used",
    "usedUnlimited": "used (unlimited)",
    "year": "Year"
  },
  "timesheet": {
    "addBreak": "Add break",
    "addRow": "Add project/task",
    "approvalPeriod": "Approval period {{period}}",
    "clearTemplate": "Remove template",
    "copyLastWeek": "Copy rows from last week",
    "copyLastWeekWithTimes": "Copy last week including times",
    "editFields": "Row fields",
    "empty": "This week is empty. Add a row or copy last week.",
    "fieldsHint": "The values apply to all entries of this row in the week (except locked ones) and to new entries.",
    "fieldsHintNew": "The values are used for the entries you create in this row.",
    "fieldsMissing": "Required fields missing",
    "fieldsMixed": "Different values during the week: {{names}}. A new value applies to all entries.",
    "fields_one": "{{count}} field filled",
    "fields_other": "{{count}} fields filled",
    "hint": "Enter a duration (e.g. 1:30, 1.5 or 90m) and confirm with Enter or Tab. Clearing removes the time for that day.",
    "multipleEntries": "{{count}} entries – a change adjusts the last entry",
    "saveTemplate": "Save as template",
    "submit": "Submit for approval",
    "templateSaved": "Template saved"
  },
  "tracker": {
    "add": "Add",
    "addDescription": "Add description",
    "approved": "Approved",
    "billable": "Billable",
    "break": "Break",
    "breakMode": "Break (key B)",
    "breakPlaceholder": "Break",
    "bulkEdit": "Edit",
    "bulkEditTitle": "Edit {{count}} entries",
    "changeProject": "Change project",
    "continue": "Continue",
    "date": "Date",
    "deleted": "Entry deleted",
    "description": "Description",
    "discard": "Discard timer",
    "duplicate": "Duplicate",
    "duration": "Duration",
    "editEntry": "Edit entry",
    "empty": "No entries yet. Start the timer or add time manually.",
    "end": "End",
    "endTime": "End time",
    "groupCount": "{{count}} similar entries",
    "invoiced": "Invoiced",
    "keep": "Keep",
    "lastWeek": "Last week",
    "loadMore": "Load older entries",
    "locked": "Locked",
    "manualMode": "Manual",
    "nonBillable": "Non-billable",
    "overtime": "Overtime",
    "pending": "Pending approval",
    "project": "Project",
    "select": "Select",
    "selectDay": "Select all entries of the day",
    "selectedCount": "{{count}} entries selected",
    "splitHalf": "Split in half",
    "start": "Start",
    "startTime": "Start time",
    "stop": "Stop",
    "tags": "Tags",
    "tagsAdd": "Add",
    "tagsRemove": "Remove",
    "tagsReplace": "Replace",
    "thisWeek": "This week",
    "timerMode": "Timer",
    "today": "Today",
    "total": "Total",
    "weekTotal": "Week total",
    "whatAreYouWorkingOn": "What are you working on?",
    "yesterday": "Yesterday"
  },
  "verifyEmail": {
    "done": "Your email address has been verified.",
    "invalid": "The link is invalid or has expired.",
    "title": "Verify email address"
  },
  "webhooks": {
    "apiText": "All features are available through the REST API. Create personal API keys in your profile. Documentation:",
    "apiTitle": "REST API",
    "attempts": "{{count}} attempt(s)",
    "create": "Create webhook",
    "deleteText": "Delete webhook \"{{name}}\"?",
    "deleteTitle": "Delete webhook",
    "deliveries": "Delivery log",
    "deliveriesOf": "Deliveries – {{name}}",
    "edit": "Edit webhook",
    "empty": "No webhooks yet.",
    "enabled": "Enabled",
    "events": "Events",
    "name": "Name",
    "noDeliveries": "No deliveries yet.",
    "notInPlan": "Webhooks are not included in the current plan.",
    "ping": "Send test",
    "redeliver": "Redeliver",
    "rotate": "New secret",
    "secret": "Signing secret",
    "signatureHint": "Header \"Firetracker-Signature: t=<timestamp>,v1=<HMAC-SHA256 of timestamp.body>\"",
    "text": "On events (e.g. a new time entry) Firetracker sends a signed HTTP POST request to your URL. Failed deliveries are retried with increasing delays.",
    "title": "Webhooks",
    "url": "Target URL"
  },
  "workspace": {
    "create": "Create workspace",
    "name": "Workspace name",
    "noneText": "You are not in an active workspace. Create a new one or accept an invitation.",
    "noneTitle": "No workspace"
  }
}
